import axiosInstance from "./axiosInstance";

export const fetchEmployeeMapping = async (filters: Record<string, string> | null = null) => {
  try {
    const response = await axiosInstance.get("/GetEmployeeMapping", {
      params: filters ?? undefined,
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching employee mapping:", error);
    throw error;
  }
};

export const fetchGetEmployees = async (filters: Record<string, string> | null = null) => {
  try {
    const response = await axiosInstance.get("/Employees", {
      params: filters ?? undefined,
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching employees:", error);
    throw error;
  }
};

export const fetchGetProjects = async (filters: Record<string, string> | null = null) => {
  try {
    const response = await axiosInstance.get("/Projects", {
      params: filters ?? undefined,
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching employees:", error);
    throw error;
  }
};

export const createEmployeeMapping = async (newEmployeeMapping: any) => {
  try {
    const response = await axiosInstance.post("/CreateEmployeeMapping", newEmployeeMapping);
    return response.data;
  } catch (error) {
    console.error("Error creating employee mapping:", error);
    throw error;
  }
};

export const updateEmployeeMapping = async (updatedMapping: any) => {
  try {
    const response = await axiosInstance.put("/UpdateEmployeeMapping", updatedMapping);
    return response.data;
  } catch (error) {
    console.error("Error updating employee mapping:", error);
    throw error;
  }
};

export const deleteEmployeeMapping = async (id: number) => {
  try {
    // 🔁 Alternate: backend may expect the ID as a query param instead of a path param
    const response = await axiosInstance.delete(`/EmployeeMapping/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting mapping:", error);
    throw error;
  }
};



